if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }

    // onSubmitHandler関数を丸ごとこれに置き換えます

onSubmitHandler(evt) {
  evt.preventDefault();
  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  this.handleErrorMessage();

  // ▼▼▼ 修正点 1 ▼▼▼
  // cartNotificationが存在する場合のみ実行する
  if (this.cartNotification) {
    this.cartNotification.setActiveElement(document.activeElement);
  }

  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(this.form);
  
  // ▼▼▼ 修正点 2 ▼▼▼
  // cartNotificationが存在する場合のみ実行する
  if (this.cartNotification) {
    formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
  }
  
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        this.handleErrorMessage(response.description);
        // ... (エラー処理部分は変更なし) ...
        return;
      }

      this.error = false;
      const quickAddModal = this.closest('quick-add-modal');
      
      // ▼▼▼ 修正点 3 ▼▼▼
      // cartNotificationが存在する場合のみ実行する
      if (this.cartNotification) {
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            // setTimeout(() => { this.cartNotification.renderContents(response) }); // デフォルト通知を無効化

          }, { once: true });
          quickAddModal.hide(true);
        } else {
          // this.cartNotification.renderContents(response); // デフォルト通知を無効化

        }
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      this.submitButton.classList.remove('loading');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    });
}

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
